import React from 'react';

const Home: React.FC = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h1 style={{ 
        fontSize: '48px', 
        marginBottom: '32px',
        fontFamily: 'Gabarito, sans-serif'
      }}>
        Welcome World
      </h1>
    </div>
  );
};

export default Home; 